module.exports = __webpack_public_path__ + "static/media/LockOpen.c29fa675.svg";